import { useTranslation } from 'react-i18next'
import { SEO } from '@/components/SEO'
import { HeroSection } from './HeroSection'
import { PrivacyContent } from './PrivacyContent'

export function PrivacyPage() {
  const { t } = useTranslation('common')

  return (
    <>
      <SEO
        title={t('privacy.metaTitle')}
        description={t('privacy.metaDescription')}
        type="website"
      />

      <HeroSection />
      <PrivacyContent />
    </>
  )
}
